import { useEffect } from 'react';
import MainLayout from '../layouts/MainLayout';
import { useLocation } from 'react-router-dom';
import history from '../assets/img/1940-Mahasabha/1940-Mahasabha-All-India-Image-1.png';
import history2 from '../assets/img/1940-Mahasabha/1940-Mahasabha-All-India-Image-2.png';
import teej from '../assets/img/teej/teej-13.png';
import fest from '../assets/img/bhoomi-pujan/bhumi-pujan-21.png';
import mahawarImg from '../assets/img/building/building-image.jpeg';
function About() {
    const { hash } = useLocation();

    useEffect(() => {
        if (hash) {
            const element = document.getElementById(hash.substring(1));
            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({ behavior: 'smooth' });
                }, 100); // Small timeout to ensure DOM is fully rendered before scrolling
            }
        } else {
            window.scrollTo(0, 0); // Scroll to top if no hash is present
        }
    }, [hash]);

    return (
        <MainLayout>

            {/* =========================================================
          Premium "About Mahawar Sabha" Heritage Section 
          ========================================================= */}
            <div id="about" className="bg-heritage-cream overflow-hidden">

                {/* 1. Hero Header */}
                <section className="container py-5 mt-4">
                    <div className="row align-items-center g-5">
                        <div className="col-lg-6 z-2">
                            <span className="badge bg-heritage-gold text-dark mb-3 px-3 py-2 rounded-pill fw-bold shadow-sm">
                                इतिहास
                            </span>
                            <h2 className="display-4 fw-bold text-heritage-maroon mb-3 text-uppercase">
                                महावर सभा का गौरवशाली इतिहास
                            </h2>
                            <p className="fw-bold">
                                महावर सभा रेवाड़ी के महावर वैश्य समाज की ऐतिहासिक यात्रा, संस्कृति और परंपराओं का प्रतीक है।
                            </p>

                            <div className="fs-6">
                                <p>
                                    महावर वैश्य समाज भारत के प्राचीन वैश्य समुदाय की एक प्रतिष्ठित शाखा है, जिसका इतिहास भारतीय व्यापार, संस्कृति और सामाजिक विकास से गहराई से जुड़ा हुआ है। वैश्य वर्ण को प्राचीन भारतीय समाज में व्यापार, कृषि, पशुपालन तथा आर्थिक गतिविधियों का प्रमुख दायित्व सौंपा गया था। महावर समाज ने इसी गौरवशाली परंपरा को आगे बढ़ाते हुए विभिन्न क्षेत्रों में अपनी विशिष्ट पहचान स्थापित की।
                                </p>

                                <p>
                                    ऐतिहासिक रूप से महावर समाज के लोग व्यापार, अनाज मंडियों, वस्त्र व्यवसाय, वित्तीय सेवाओं, कृषि तथा सामाजिक सेवा कार्यों में सक्रिय रहे हैं। राजस्थान, हरियाणा, दिल्ली, उत्तर प्रदेश, पंजाब तथा मध्य प्रदेश सहित देश के विभिन्न क्षेत्रों में महावर समाज की उपस्थिति लंबे समय से देखने को मिलती है। समय के साथ यह समाज देश की सीमाओं से बाहर भी अपनी पहचान स्थापित करने में सफल रहा है।
                                </p>
                            </div>

                        </div>
                        <div className="col-lg-6 position-relative">
                            <div className="decorative-pattern-bg position-absolute top-50 start-50 translate-middle w-100 h-100 z-0"></div>
                            <div className="img-wrapper rounded-4 shadow-elegant overflow-hidden position-relative z-1 hover-lift">
                                <img src={history2} alt="Indian Temple" className="img-fluid w-100 img-heritage object-fit-cover" />
                                <div className="soft-overlay"></div>
                            </div>
                            <p className="fw-bold fs-3 text-center mt-5">1940-अखिल भारतवर्ष महावर वैश्य महासभा</p>
                        </div>


                        <p class="mt-2 fs-6">
                            मध्यकालीन भारत में महावर समाज के अनेक परिवार व्यापारिक मार्गों के माध्यम से विभिन्न नगरों और राज्यों में पहुंचे। उन्होंने अपने परिश्रम, ईमानदारी, व्यावसायिक कुशलता तथा सामाजिक मूल्यों के आधार पर समाज में सम्मानजनक स्थान प्राप्त किया। राजस्थान के मारवाड़, मेवाड़, अजमेर, अलवर तथा सवाई माधोपुर क्षेत्रों से लेकर हरियाणा के रेवाड़ी, गुरुग्राम और उत्तर भारत के अनेक नगरों तक महावर समाज का विस्तार हुआ।
                        </p>

                        <p className="mt-1 fs-6">
                            महावर सभा रेवाड़ी की स्थापना भी इसी महान उद्देश्य के साथ की गई। यह संस्था समाज के सभी वर्गों को जोड़ने, पारिवारिक संबंधों को सुदृढ़ बनाने, युवा पीढ़ी को मार्गदर्शन देने तथा समाज की सांस्कृतिक विरासत को संरक्षित रखने का कार्य कर रही है। सभा द्वारा समय-समय पर सामाजिक, धार्मिक, शैक्षिक एवं सांस्कृतिक कार्यक्रम आयोजित किए जाते हैं, जिनसे समाज में जागरूकता और सहयोग की भावना बढ़ती है।
                        </p>

                        <p className="mt-1 fs-6">
                            महावर सभा का प्रमुख उद्देश्य केवल सामाजिक संगठन तक सीमित नहीं है, बल्कि समाज के सर्वांगीण विकास को सुनिश्चित करना भी है। इसके अंतर्गत विद्यार्थियों को छात्रवृत्ति प्रदान करना, मेधावी छात्रों का सम्मान करना, करियर मार्गदर्शन उपलब्ध कराना, महिला सशक्तिकरण कार्यक्रम चलाना तथा युवाओं के लिए व्यक्तित्व विकास एवं रोजगार संबंधी गतिविधियों का आयोजन करना शामिल है।
                        </p>

                        <p className="mt-1 fs-6">
                            समाज सेवा महावर सभा की मूल भावना रही है। संस्था द्वारा रक्तदान शिविर, निःशुल्क चिकित्सा शिविर, स्वास्थ्य जागरूकता अभियान, आर्थिक सहायता कार्यक्रम, विवाह सहायता तथा आपदा राहत कार्यों का आयोजन किया जाता है। इन प्रयासों के माध्यम से समाज के जरूरतमंद वर्गों तक सहायता पहुंचाई जाती है और सेवा की परंपरा को आगे बढ़ाया जाता है।
                        </p>
                        <div className="col-lg-6 position-relative">
                            <div className="decorative-pattern-bg position-absolute top-50 start-50 translate-middle w-100 h-100 z-0"></div>
                            <div className="img-wrapper rounded-4 shadow-elegant overflow-hidden position-relative z-1 hover-lift">
                                <img src={history} alt="Indian Temple" className="img-fluid w-100 img-heritage object-fit-cover" />
                                <div className="soft-overlay"></div>
                            </div>
                            <p className="fw-bold fs-3 text-center mt-5">1940-अखिल भारतवर्ष महावर वैश्य महासभा</p>
                        </div>
                        <div className="col-lg-6 z-2">

                            <p className="mt-2 fs-6">
                                महावर समाज की सांस्कृतिक पहचान उसकी सबसे बड़ी धरोहर है। महावर सभा विभिन्न धार्मिक एवं सांस्कृतिक आयोजनों के माध्यम से समाज की परंपराओं को जीवित रखने का कार्य करती है। होली मिलन, दीपावली उत्सव, जन्माष्टमी, राम नवमी, भजन संध्या, धार्मिक प्रवचन तथा सांस्कृतिक प्रतियोगिताओं जैसे कार्यक्रम समाज को अपनी जड़ों से जोड़े रखते हैं।
                            </p>

                            <p className="mt-2 fs-6">
                                वर्तमान समय में महावर सभा आधुनिक तकनीक और डिजिटल माध्यमों का उपयोग करते हुए समाज को नई दिशा प्रदान कर रही है। संस्था शिक्षा, रोजगार, उद्यमिता और सामाजिक जागरूकता के क्षेत्र में निरंतर कार्य कर रही है ताकि आने वाली पीढ़ियां अपनी सांस्कृतिक पहचान को बनाए रखते हुए आधुनिक युग की चुनौतियों का सफलतापूर्वक सामना कर सकें।
                            </p>

                            <p className="mt-2 fs-6">
                                आज महावर समाज राजस्थान, हरियाणा, पंजाब, उत्तर प्रदेश, दिल्ली सहित भारत के अनेक राज्यों तथा विदेशों में अपनी सक्रिय उपस्थिति बनाए हुए है। महावर सभा रेवाड़ी समाज की इसी गौरवशाली विरासत, एकता, सेवा भावना और सांस्कृतिक मूल्यों का प्रतिनिधित्व करती है तथा "एकता, सेवा और संस्कार के साथ समाज का विकास" के आदर्श को आगे बढ़ाने के लिए निरंतर प्रयासरत है।।
                            </p>


                            <p className="mt-2 fs-6">
                                महावर समाज सदैव शिक्षा, संस्कार, सेवा और सामाजिक एकता को प्राथमिकता देता आया है। समाज के लोगों ने विद्यालयों, धर्मशालाओं, गौशालाओं, धार्मिक स्थलों और सामाजिक संस्थाओं के निर्माण में महत्वपूर्ण योगदान दिया। समाज के वरिष्ठजनों ने नई पीढ़ी को पारिवारिक मूल्यों, सामाजिक उत्तरदायित्व और राष्ट्र सेवा के संस्कार प्रदान किए।
                            </p></div>
                    </div>
                </section>
                <section className="container py-5">
                    <div className="row g-5 align-items-center flex-lg-row-reverse">
                        <h2 className="fw-bold text-heritage-maroon mb-4 text-center">हमारा ऐतिहासिक विश्वास और संस्कृति</h2>
                        <div className="col-lg-5">
                            <div className="img-wrapper rounded-4 shadow-elegant overflow-hidden hover-lift">
                                <img src={fest} alt="Lord Ganesha" className="img-fluid w-100 img-heritage object-fit-cover" />
                            </div>
                            <div className="img-wrapper rounded-4 mt-5 shadow-elegant overflow-hidden hover-lift">
                                <img src={teej} alt="Lord Ganesha" className="img-fluid w-100 img-heritage object-fit-cover" />
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="row g-4 ">
                                {[
                                    {
                                        title: 'धर्म और समृद्धि',
                                        desc: 'महावर समुदाय में धर्म और आर्थिक समृद्धि को एक-दूसरे का पूरक माना जाता है। दीवाली पर खाता खोलने की परंपरा, लक्ष्मी पूजा और गणेश का आह्वान इस संस्कृति के अभिन्न अंग हैं। व्यापार में ईमानदारी, दानशीलता और धार्मिक आस्था को साथ लेकर चलना इस समाज की पहचान है।'
                                    },
                                    {
                                        title: 'पारिवारिक बंधन',
                                        desc: 'परिवार में सम्मान, बुजुर्गों की सेवा और एक-दूसरे की सहायता महावरों की सबसे बड़ी विशेषता रही है। विवाह, जन्म और मृत्यु के संस्कारों में यह परंपराएँ स्नेह और अनुशासन का प्रतीक हैं। परिवार के भीतर सामूहिक निर्णय, परंपरागत रीति-रिवाज और संस्कारों का पालन सामाजिक एकता को मजबूत करता है।'
                                    },
                                    {
                                        title: 'त्योहार और उत्सव',
                                        desc: 'होली, दिवाली, जन्माष्टमी, रामनवमी और अन्य पर्व महावर समाज में उत्साह और श्रद्धा के साथ मनाए जाते हैं। प्रत्येक उत्सव में भगवान की आराधना, गीत, भजन, पारंपरिक व्यंजन और सामूहिक मिलन शामिल होता है। इन उत्सवों के माध्यम से समाज में भाईचारा और सांस्कृतिक गौरव जीवित रहता है।'
                                    },
                                    {
                                        title: 'तीर्थ और परंपरा',
                                        desc: 'महावर परिवार पवित्र तीर्थों का दर्शन करते हैं और वंश परंपरा को आगे बढ़ाते हैं। गंगा, यमुना, वृंदावन और हरिद्वार जैसी पवित्र स्थलों की यात्रा विश्वास और भक्ति का प्रतीक है। तीर्थयात्राएँ केवल धार्मिक आस्था ही नहीं बल्कि सामाजिक मेलजोल और सांस्कृतिक आदान-प्रदान का भी माध्यम हैं।'
                                    },
                                    {
                                        title: 'शिक्षा और मार्गदर्शन',
                                        desc: 'महावर समाज में शिक्षा को प्रगति का आधार माना जाता है। बच्चों को उच्च शिक्षा दिलाने, छात्रवृत्ति देने और करियर मार्गदर्शन प्रदान करने की परंपरा समाज को आधुनिक युग में प्रतिस्पर्धी बनाती है। युवाओं को संस्कार और आधुनिकता का संतुलन सिखाया जाता है।'
                                    },
                                    {
                                        title: 'संस्कृति और कला',
                                        desc: 'महावर समाज में भजन, कीर्तन, लोकगीत और पारंपरिक नृत्य सांस्कृतिक जीवन का हिस्सा हैं। विवाह और उत्सवों में संगीत और कला का विशेष स्थान होता है। यह परंपराएँ आने वाली पीढ़ियों को अपनी जड़ों से जोड़ने का कार्य करती हैं।'
                                    }

                                ].map((belief, idx) => (
                                    <div className="col-md-6" key={idx}>
                                        <div className="glass-card p-4 rounded-4 shadow-sm border-gold hover-lift h-100">
                                            <h5 className="text-heritage-maroon fw-bold mb-2">{belief.title}</h5>
                                            <p className="mb-0 fs-6">{belief.desc}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>


            </div>
        </MainLayout>
    );
}

export default About;
